import React, { useEffect, useRef } from 'react';

const InputLevelMeter = ({ stream, audioContext }) => {
    const analyserRef = useRef(null);
    const meterRef = useRef(null);
    const animationIdRef = useRef(null);
    const sourceRef = useRef(null);

    useEffect(() => {
        if (!stream || !audioContext) return;

        if (!analyserRef.current) {
            analyserRef.current = audioContext.createAnalyser();
            analyserRef.current.fftSize = 2048;
        }

        sourceRef.current = audioContext.createMediaStreamSource(stream);
        sourceRef.current.connect(analyserRef.current);

        const bufferLength = analyserRef.current.fftSize;
        const dataArray = new Uint8Array(bufferLength);

        const drawMeter = () => {
            analyserRef.current.getByteTimeDomainData(dataArray);
            let max = 0;
            for (let i = 0; i < bufferLength; i++) {
                const value = dataArray[i];
                const normalizedValue = Math.abs(value - 128) / 128; // 振幅を0〜1の範囲にスケーリング
                if (normalizedValue > max) {
                    max = normalizedValue;
                }
            }

            // 振幅値とdB値をコンソールに表示
            const dBValue = 20 * Math.log10(max);
            // console.log(`Amplitude: ${max.toFixed(3)}, dB: ${dBValue.toFixed(2)}`);

            // 対数スケールでバーの幅を設定
            const peakLevel = (dBValue + 60) / 60 * 100; // -60dB to 0dB を 0% to 100% にスケーリング
            meterRef.current.style.width = Math.max(0, peakLevel) + '%';

            // バーの色を変更
            if (dBValue >= -1.0) {
                meterRef.current.style.backgroundColor = 'red'; // クリッピング
            } else if (dBValue >= -6.0 && dBValue < -1.0) {
                meterRef.current.style.backgroundColor = 'yellow'; // -6dB以上-1dB未満
            } else {
                meterRef.current.style.backgroundColor = 'green'; // 通常
            }

            animationIdRef.current = requestAnimationFrame(drawMeter);
        };

        drawMeter();

        return () => {
            cancelAnimationFrame(animationIdRef.current);
            if (sourceRef.current) {
                sourceRef.current.disconnect();
            }
        };
    }, [stream, audioContext]);

    return (
        <div className="level-meter">
            <div
                ref={meterRef}
                className="level-meter-bar"
            ></div>
        </div>
    );
};

export default InputLevelMeter;
